import { createContext, useContext } from 'react'
import { CROP_MODAL_ACTION_TYPES } from './crop-modal-context-reducer'

export const CropModalContext = createContext(null)
export const CropModalContextDispatch = createContext(null)

export const useCropModalContext = () => {
  const context = useContext(CropModalContext)
  if (!context) throw new Error('useCropModalContext must be used within CropModalContextProvider')
  return context
}

export const useCropModalContextDispatch = () => {
  const dispatch = useContext(CropModalContextDispatch)
  if (!dispatch) throw new Error('useCropModalContextDispatch must be used within CropModalContextProvider')
  return dispatch
}

// Action creators

export const setSpecies = ({ species, archetype }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_SPECIES, species, archetype,
})

export const setVariety = ({ variety }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_VARIETY, variety,
})

export const setCount = ({ count }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_COUNT, count,
})

export const setIndoorOffset = ({ indoorOffset }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_INDOOR_OFFSET, indoorOffset,
})

export const setOutdoorOffset = ({ outdoorOffset }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_OUTDOOR_OFFSET, outdoorOffset,
})

export const setDtm = ({ dtm }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_DTM, dtm,
})

export const setGrowthType = ({ growthType }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_GROWTH_TYPE, growthType,
})

export const setLifecycleType = ({ lifecycleType }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_LIFECYCLE_TYPE, lifecycleType,
})

export const setPropagationCode = ({ propagationCode }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_PROPAGATION_CODE, propagationCode,
})

export const setSelectedCollections = ({ selectedCollections }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_SELECTED_COLLECTIONS, selectedCollections,
})

export const togglePhaseCode = ({ phaseCode, effectivePhaseCodes }) => ({
  type: CROP_MODAL_ACTION_TYPES.TOGGLE_PHASE_CODE, phaseCode, effectivePhaseCodes,
})

export const toggleTaskCode = ({ taskCode, effectiveTaskCodes }) => ({
  type: CROP_MODAL_ACTION_TYPES.TOGGLE_TASK_CODE, taskCode, effectiveTaskCodes,
})

export const setSelectedPhaseCodes = ({ selectedPhaseCodes }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_SELECTED_PHASE_CODES, selectedPhaseCodes,
})

export const setSelectedTaskCodes = ({ selectedTaskCodes }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_SELECTED_TASK_CODES, selectedTaskCodes,
})

export const setAdjustedPhases = ({ adjustedPhases }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_ADJUSTED_PHASES, adjustedPhases,
})

export const setAdjustedTasks = ({ adjustedTasks }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_ADJUSTED_TASKS, adjustedTasks,
})

export const setNotes = ({ notes }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_NOTES, notes,
})

export const setTaskNotes = ({ taskCode, notes }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_TASK_NOTES, taskCode, notes,
})

export const setShowNotes = ({ showNotes }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_SHOW_NOTES, showNotes,
})

export const setShowCropSchedule = ({ showCropSchedule }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_SHOW_CROP_SCHEDULE, showCropSchedule,
})

export const setUserOrg = ({ orgId, orgName }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_USER_ORG, orgId, orgName,
})

export const setSpeciesTouched = ({ speciesTouched }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_SPECIES_TOUCHED, speciesTouched,
})

export const setSuccessions = ({ successions }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_SUCCESSIONS, successions,
})

export const loadEditCrop = ({ crop, archetype, template, variety, count }) => ({
  type: CROP_MODAL_ACTION_TYPES.LOAD_EDIT_CROP, crop, archetype, template, variety, count,
})

export const setBulkAdd = ({ bulkAdd }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_BULK_ADD, bulkAdd,
})

export const enqueueCrop = ({ cropEntry }) => ({
  type: CROP_MODAL_ACTION_TYPES.ENQUEUE_CROP, cropEntry,
})

export const resetForm = () => ({
  type: CROP_MODAL_ACTION_TYPES.RESET_FORM,
})

export const resetCropModal = () => ({
  type: CROP_MODAL_ACTION_TYPES.RESET,
})

export const setCustomCropMode = ({ isCustomCrop }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_CUSTOM_CROP_MODE, isCustomCrop,
})

export const setCustomSpeciesName = ({ customSpeciesName }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_CUSTOM_SPECIES_NAME, customSpeciesName,
})

export const setCustomVarietyMode = ({ isCustomVariety }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_CUSTOM_VARIETY_MODE, isCustomVariety,
})

export const setCustomVarietyName = ({ customVarietyName }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_CUSTOM_VARIETY_NAME, customVarietyName,
})

export const setCustomFamilyCode = ({ customFamilyCode }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_CUSTOM_FAMILY_CODE, customFamilyCode,
})

export const setArchetype = ({ archetype }) => ({
  type: CROP_MODAL_ACTION_TYPES.SET_ARCHETYPE, archetype,
})
